import React from 'react';
import PropTypes from 'prop-types';

import {TaskType} from '../../../constants/dataEnum';

import './TaskVolume.scss';

function TaskVolume({volume, type}) {
  return (
    <div className="task-volume">
      {(type === TaskType.ASPIRATE || type === TaskType.PICK_TIP) && <span className="glyphicon glyphicon-arrow-up" />}
      {(type === TaskType.DISPENSE || type === TaskType.EJECT_TIP) && (
        <span className="glyphicon glyphicon-arrow-down" />
      )}
      <span className="volume">
        {`${volume} ${type === TaskType.PICK_TIP || type === TaskType.EJECT_TIP ? 'tips' : 'μL'}`}
      </span>
    </div>
  );
}

TaskVolume.propTypes = {
  volume: PropTypes.number,
  type: PropTypes.string,
};

TaskVolume.defaultProps = {
  volume: 0,
  type: '',
};

export default React.memo(TaskVolume);
